import { lazy, Suspense } from 'react';
import { TestHarness } from './screens/TestHarness';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SplashScreen } from './components/LoadingOverlay';

// Check for test harness route before component renders
// Handle both with and without trailing slash
const isTestHarness =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/dev/test-harness' ||
    window.location.pathname === '/dev/test-harness/');

// Lazy load MainApp to avoid loading playerStore in test harness mode
// This prevents the parent page from reconnecting with an old session
const MainApp = lazy(() => import('./MainApp'));

export default function App() {
  // Test harness check - done before hooks to avoid conditional hook issues
  if (isTestHarness) {
    return <TestHarness />;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<SplashScreen />}>
        <MainApp />
      </Suspense>
    </ErrorBoundary>
  );
}
